<template>
  <div class="can-not-buy">
    <hot-spot v-if="showCanNotBuy" @click.stop.prevent />
    <btn-config
      v-if="showCanNotBuy"
      :width="!!computedBtnText ? computedBtnWidth : 0"
      :font-color="'#8c8c8c'"
      :text="computedBtnText"
      :icon-size="'16px'"
    />
  </div>
</template>
<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
import { NEW_ADD_CART_STEP } from '@/defines/const'

export default {
  name: 'ContNotBuyComp',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    btnWidth: {
      type: Number,
      default: 0.52
    },
    goodsStatus: {
      type: Number,
      default: 0
    },
    statusShowName: {
      type: String,
      default: ''
    },
    noBuyTimeShow: {
      type: String,
      default: ''
    },
    openRemind: {
      type: String,
      default: ''
    },
    addStepType: {
      type: String,
      default: 'normal'
    },
    showCanNotBuy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    computedBtnWidth() {
      const stepType = NEW_ADD_CART_STEP[this.addStepType]
      return stepType.noticeInputBtnWidth
    },
    computedBtnText() {
      const statusShowName =
        [0, 2, 4, 5].indexOf(this.goodsStatus) > -1
          ? this.noBuyTimeShow
          : this.statusShowName
      // eslint-disable-next-line eqeqeq
      return this.goodsStatus == 9 ? this.openRemind : statusShowName
    }
  }
}
</script>

<style lang="scss" scoped>
.can-not-buy {
  position: relative;

  height: 28px;

  @include flex-row-center;

  .can-not-buy-info {
    width: 72px;
    height: 22px;

    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 11px;
    border: 1px solid $theme-main;

    font-size: 12px;
    line-height: 22px;
    text-align: center;

    color: $theme-main;
    box-shadow: 0 3px 6px 0 white;

    @include flex-row-center;
  }
}
</style>
